import AnimationProperty from './AnimationProperty';
import GeneralProperty from './GeneralProperty';
import IframeProperty from './IframeProperty';
import ImageFilterProperty from './ImageFilterProperty';
import ImageProperty from './ImageProperty';
import LinkProperty from './LinkProperty';
import MapProperty from './MapProperty';
import MarkerProperty from './MarkerProperty';
import ShadowProperty from './ShadowProperty';
import StyleProperty from './StyleProperty';
import TextProperty from './TextProperty';
import TooltipProperty from './TooltipProperty';
import UserProperty from './UserProperty';
import VideoProperty from './VideoProperty';

type PropertyRenderer = {
	render: (...args: any[]) => any;
};

type PropertySection = {
	title: string;
	component: PropertyRenderer;
};

type PropertyDefinitionMap = Record<string, Record<string, PropertySection>>;

const PropertyDefinition: PropertyDefinitionMap = {
	map: {
		map: {
			title: 'Map',
			component: MapProperty,
		},
		image: {
			title: 'Image',
			component: ImageProperty,
		},
	},
	group: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
	},
	'i-text': {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		marker: {
			title: 'Marker',
			component: MarkerProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	textbox: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		text: {
			title: 'Text',
			component: TextProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	image: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		image: {
			title: 'Image',
			component: ImageProperty,
		},
		filter: {
			title: 'Filter',
			component: ImageFilterProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	triangle: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	rect: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	circle: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	polygon: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	line: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	arrow: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
	video: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		video: {
			title: 'Video',
			component: VideoProperty,
		},
	},
	element: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
	},
	iframe: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		video: {
			title: 'Iframe',
			component: IframeProperty,
		},
	},
	svg: {
		general: {
			title: 'General',
			component: GeneralProperty,
		},
		link: {
			title: 'Link',
			component: LinkProperty,
		},
		tooltip: {
			title: 'Tooltip',
			component: TooltipProperty,
		},
		style: {
			title: 'Style',
			component: StyleProperty,
		},
		shadow: {
			title: 'Shadow',
			component: ShadowProperty,
		},
		animation: {
			title: 'Animation',
			component: AnimationProperty,
		},
		userProperty: {
			title: 'User Property',
			component: UserProperty,
		},
	},
};

export default PropertyDefinition;
